import { useState } from 'react';
import { useButtons } from './ButtonProvider';
import { useAuth } from '../auth/AuthProvider';
import { isStandalone } from '../detector';
import { LogIn } from 'lucide-react';
import { LoginModal } from '../../components/LoginModal';
import './StandaloneButtons.css';

/**
 * Renders MainButton and SecondaryButton for standalone mode
 * In Telegram mode, this component renders nothing (Telegram provides the buttons)
 * For guest users, shows only a "Login with Telegram" button
 */
export function StandaloneButtons() {
  const { mainButton, secondaryButton } = useButtons();
  const { isGuest } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);

  // Don't render anything in Telegram mode
  if (!isStandalone) return null;

  // For guest users, show only the login button
  if (isGuest) {
    return (
      <>
        <div className="standalone-buttons-container">
          <div className="standalone-buttons">
            <button
              className="standalone-btn primary login-btn"
              onClick={() => setShowLoginModal(true)}
              type="button"
            >
              <LogIn size={20} />
              Log in with Telegram
            </button>
          </div>
        </div>
        <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
      </>
    );
  }

  // Only show container if there are buttons to display
  const hasButtons = mainButton.visible || secondaryButton.visible;
  if (!hasButtons) return null;

  return (
    <div className="standalone-buttons-container">
      <div className="standalone-buttons">

        {/* Secondary button (left position) */}
        {secondaryButton.visible && secondaryButton.position === 'left' && (
          <button
            className="standalone-btn secondary"
            onClick={secondaryButton.onClick}
            type="button"
          >
            {secondaryButton.text}
          </button>
        )}

        {/* Main button */}
        {mainButton.visible && (
          <button
            className={`standalone-btn primary ${mainButton.loading ? 'loading' : ''}`}
            onClick={mainButton.onClick}
            disabled={mainButton.disabled || mainButton.loading}
            type="button"
            style={{
              backgroundColor: mainButton.color || undefined,
              color: mainButton.textColor || undefined
            }}
          >
            {mainButton.loading ? (
              <span className="standalone-btn-spinner" />
            ) : (
              mainButton.text
            )}
          </button>
        )}

        {/* Secondary button (right position) */}
        {secondaryButton.visible && secondaryButton.position === 'right' && (
          <button
            className="standalone-btn secondary"
            onClick={secondaryButton.onClick}
            type="button"
          >
            {secondaryButton.text}
          </button>
        )}
      </div>
    </div>
  );
}
